import React from 'react';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { CardImage } from '@spotahome/ui-library';

import './CardsImages.scss';

const CARD_IMAGE_WIDTH = 366;

const CardsImagesMobile = () => (
  <div>
    <div className="cards-images__row">
      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/visit-properties-mobile.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.visit-properties')}
        cardNumber={1}
      />

      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/take-photos-mobile-photo.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.take-photos')}
        cardNumber={2}
      />
    </div>

    <div className="cards-images__row">
      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/record-a-video-mobile-photo.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.video-tour')}
        cardNumber={3}
      />

      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/floorplan-mobile-photo.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.simple-floor')}
        cardNumber={4}
      />
    </div>

    <div className="cards-images__row">
      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/landlord-mobile-photo.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.complete-form')}
        cardNumber={5}
      />

      <CardImage
        cardImage={getResourcePath(
          '/images/home-checker/edit-and-upload-mobile-photo.jpg'
        )}
        cardImageWith={CARD_IMAGE_WIDTH}
        cardText={trans('home-checker.mission.edit-material')}
        cardNumber={6}
      />
    </div>
  </div>
);

export default CardsImagesMobile;
